import { useLayoutEffect, useState } from "react";

export const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(() => window.pageYOffset)

  const updatePosition = () => {
    setScrollPosition(window.pageYOffset)
  };

  useLayoutEffect(() => {

    updatePosition()
    window.addEventListener("scroll", updatePosition);

    return () => window.removeEventListener("scroll", updatePosition);

  }, [])

  return scrollPosition;
}